import { ButtonDesignTokens } from '@primeuix/themes/types/button';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/button/index.ts
const btn = componentColorScheme.button;

export const ButtonTelekomDT: ButtonDesignTokens = {
  colorScheme: {
    light: {
      outlined: {
        primary: tFlat(btn.outlined.primary),
        secondary: tFlat(btn.outlined.secondary),
        danger: tFlat(btn.outlined.danger),
        success: tFlat(btn.outlined.success),
        contrast: tFlat(btn.outlined.contrast),
        help: tFlat(btn.outlined.help),
        info: tFlat(btn.outlined.info),
        plain: tFlat(btn.outlined.plain),
        warn: tFlat(btn.outlined.warn),
      },
      text: {
        primary: tFlat(btn.text.primary),
        secondary: tFlat(btn.text.secondary),
        danger: tFlat(btn.text.danger),
        success: tFlat(btn.text.success),
        contrast: tFlat(btn.text.contrast),
        help: tFlat(btn.text.help),
        info: tFlat(btn.text.info),
        plain: tFlat(btn.text.plain),
        warn: tFlat(btn.text.warn),
      },
      link: tFlat(btn.link),
      root: {
        secondary: { focusRing: tFlat(btn.secondary.focus.ring) },
        success: tFlat(btn.success),
        danger: tFlat(btn.danger),
        info: tFlat(btn.info),
        warn: tFlat(btn.warn),
        help: tFlat(btn.help),
        contrast: tFlat(btn.contrast),
      },
    },
  },
};
